<template>
	<div class="card">
        <preloader v-if="loading"></preloader>
        <div class="card-body p-1">
            <div class="media">
                <div class="align-self-center text-center px-3 bg-light text-dark">
                    <p v-if="calificacion.tasa == 0">{{calificacion.calificador}}</p>
                    <h1 class="mt-0" v-text="calificacion.calificador" v-else></h1>
                </div>
                <div class="media-body text-center bg-info text-white p-2">
                    <div>
                        <small>{{tipoVal}}</small>
                    </div>
                    <h5 class="mt-0">
                        Tasa a ofrecer:
                        
                        <div class="dropdown float-right">
                            <button class="btn btn-secondary btn-sm dropdown-toggle" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"></button>
                            <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                                <button type="button" class="dropdown-item" v-on:click="getCalificacion()">
                                    <i class="material-icons">update</i> Actualizar
                                </button>
                                <button type="button" class="dropdown-item" v-on:click="openModal()">
                                    <i class="material-icons">search</i> Ver calificación
                                </button>
                            </div>
                        </div>
                    </h5>
                    <p v-text="calificacion.tasa" class="m-0"></p>
                </div>
            </div>
        </div>

        <!-- Modal -->
        <div class="modal fade" :id="'calificacionDetalleModal'+tipoVal" role="dialog" aria-labelledby="calificacionDetalleModalLabel" aria-hidden="true">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" id="calificacionDetalleModalLabel">Detalle de calificación ({{calificacion.valor}})</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <preloader v-if="loading"></preloader>
                    <div class="modal-body">
                        <div v-for="(group, index) in calificacion.detalle">
                            <h5 class="m-0 text-muted">
                                {{index}}
                                <span class="badge badge-primary badge-pill">
                                    {{group[0].TIPO}}
                                </span>

                                <span class="float-right">
                                    {{getTotal(index)}}
                                </span>
                            </h5>

                            <table class="table table-sm table-bordered">
                                <tbody>
                                    <tr v-for="(item, index) in group">
                                        <th>
                                            {{item.DESCRIPCION_FACTOR}}
                                        </th>
                                        <td class="text-right" width="20%" v-tooltip="item.VALOR">
                                            {{item.VALOR_OPORTUNIDAD}}
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Cerrar</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
	export default {
		props: ['tipo', 'oportunidad'],

		data(){
			return {
				loading: false,
				calificacion: {
                    calificador: '',
                    tasa: '',
                    valor: '',
                    detalle: []
                },
			}
		},

		created() {
			this.getCalificacion()
		},

		methods: {
			getTotal(index){
                let total = [];
                var $module = this;

                Object.entries(this.calificacion.detalle[index])
                    .forEach(([key, val]) => {
                        total.push(val.VALOR_OPORTUNIDAD);
                    });

                return this.money(total.reduce(function(total, num){
                    return parseFloat(total || 0) + parseFloat(num || 0);
                }, 0), false);

                /*return (this..reduce(function(a, b){
                    return (a || 0) + (b. || 0);
                }, 0)).toFixed(2);*/
            },

            getCalificacion: function(){
                this.loading = true;
                axios.get(`api/prestamo/calificaciones/oportunidades/${this.oportunidadVal}?tipo=${this.tipoVal}`)
                .then(response => {
                    this.calificacion.calificador = response.data.CALIFICADOR || ''
                    this.calificacion.tasa = response.data.TASA_OFRECER || ''
                    this.calificacion.valor = response.data.VALOR || ''
                }).catch(error => {
                    console.log(error);
                    console.log(error.response);
                }).then(()=>{
                    this.loading = false;
                });
            },

            openModal: function(){
                $('#calificacionDetalleModal'+this.tipoVal).modal('show')
                this.getCalificacionDetalle()
            },

            getCalificacionDetalle: function(){
                this.loading = true;

                axios.get(`api/prestamo/calificaciones/oportunidades/${this.oportunidadVal}/detalle?tipo=${this.tipoVal}`)
                .then(response => {
                    this.calificacion.detalle = response.data
                }).catch(error => {
                    console.log(error);
                    console.log(error.response);
                }).then(()=>{
                    this.loading = false;
                });
            },
		},

		computed: {
			tipoVal(){
				return this.tipo
			},

			oportunidadVal(){
				return this.oportunidad
			}
		}
	}
</script>